import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";

type BulkSearchEvent = keyof typeof trackingEventDictionary;

export const trackBulkSearch = (event: BulkSearchEvent, properties: Record<string, unknown> = {}) => {
  trademoTrackingEvents(trackingEventDictionary[event], { ...generateTrackingObject("company-bulk-search", window.location.pathname, getUserActivePlan()), ...properties });
};
